<div id="skiplinks" href="#skiplinks" class="skiplinks" [hidden]="isHidden" >
  <nav role="navigation" aria-label="Accès rapide">
    <ul class="skiplinks-ul">
      <li *ngFor="let link of linkList">
        <a class="skiplinks-btn mat-primary" mat-raised-button [href]="link.href">{{link.label}}</a>
      </li>
    </ul>
  </nav>
</div>